export { default } from "./featuredCategories"
